import React, { useState, useEffect } from "react";
import { Button, Modal, Collapsible, CollapsibleItem } from "react-materialize";
import Html from "../../../../utils/Html";
import Func from "../../../../utils/Func";
import $ from "jquery";
import config from "../../../../config";
import API from "../../../../utils/API";

import { useAlluser } from "context/AlluserContext";
import ShowColumnModalItems from "./ShowColumnModalItems";

export default function ShowColumnModal({
  userData,
  handleEvents,
  isOpen,
  setOpenShowColumn,
}) {
  const {
    filters,
    filterData,
    inputs,
    storeFilters,
    storeFilterData,
    storeInputs,
  } = useAlluser();
  const [itemData, setItemData] = useState({
    data: {},
    status: "",
    err: 0,
    err_msg: "",
  });
  let header = "List View Settings";
  let content = "";
  let footer = "";
  let btns = [<div className="header">{header}</div>];
  let modalCSS = {};
  modalCSS.height = "80%";
  modalCSS.maxHeight = "520px";

  handleEvents.BtnSelectallShowColumn = {
    OnClick: function (evt) {
      const selectedFields = Func.GetArrayColumn(filterData.columns, "name");
      storeInputs({ ...inputs, selectedFields: selectedFields });
    },
  };
  handleEvents.BtnUnselectallShowColumn = {
    OnClick: function (evt) {
      storeInputs({ ...inputs, selectedFields: [] });
    },
  };
  handleEvents.BtnDefaultShowColumn = {
    OnClick: function (evt) {
      storeInputs({ ...inputs, selectedFields: filterData.defFields });
    },
  };
  handleEvents.ChkShowColumn = {
    OnChange: function (evt) {
      const value = evt.target.value;
      let selectedFields = [...inputs.selectedFields];
      if (evt.target.checked) {
        selectedFields.push(value);
      } else {
        selectedFields.splice(selectedFields.indexOf(value), 1);
      }
      storeInputs({ ...inputs, selectedFields: selectedFields });
    },
  };
  handleEvents.BtnSaveShowColumn = {
    OnClick: function (evt) {
      setItemData({ status: "inprocess" });
      const saveData = [...inputs.selectedFields];
      const mainFunc = async () =>
        await API.post("alluser/save/userfields", {
          params: ({
            userID: userData.idu,
            saveData: saveData,
          }),
        });
      mainFunc()
        .then((res) => {
          // console.log("alluser save userfields=", res.data);
          storeFilterData({ ...filterData, userFields: saveData });
          setItemData({ status: "", err: 0, err_msg: "" });
          storeFilters({ ...filters, keyChange: Func.GetKeyRandom() });
        })
        .catch((err) => {
          //console.log(infos.tabActive, err);
          setItemData({ status: "", err: 1, err_msg: err });
        });
    },
  };
  handleEvents.BtnCancelShowColumn = {
    OnClick: function (evt) {
      storeInputs({ ...inputs, selectedFields: filterData.userFields });
      $("body").css({ overflow: "auto" });
      setOpenShowColumn(false);
    },
  };

  useEffect(() => {}, []);

  if ("err" in itemData && itemData.err === 1) {
    modalCSS.height = "170px";
    btns.push(
      <Button
        flat
        modal="close"
        node="button"
        waves="red"
        className="modal-close"
      >
        <i className="material-icons">close</i>
      </Button>
    );
    content = (
      <div className="text-error">Fetch request error: {itemData.err_msg}</div>
    );
  } else if (itemData.status === "inprocess") {
    content = (
      <div>
        <Html.Preloading
          addon={{
            css: {
              position: "absolute",
              top: "0",
              left: "0",
              right: "0",
              bottom: "0",
              margin: "auto",
            },
          }}
        />
      </div>
    );
  } else {
    //console.log("View", itemData);
    btns.push(
      <Button
        flat
        modal="close"
        node="button"
        waves="red"
        className="modal-close"
      >
        <i className="material-icons">close</i>
      </Button>
    );

    content = (
      <div className="modal-content-outer">
        <div key="modal-content-inner" className="modal-content-inner">
          <div
            className="row"
            style={{
              marginTop: "-15px",
              paddingLeft: "10px",
              paddingRight: "10px",
            }}
          >
            <span style={{ verticalAlign: "middle" }}>Select</span>
            <Button
              flat
              node="a"
              waves="light"
              id="btn-selectall-showcolumn"
              style={{
                textDecoration: "underline",
                paddingLeft: "8px",
                paddingRight: "8px",
              }}
              onClick={handleEvents.BtnSelectallShowColumn.OnClick}
            >
              ALL
            </Button>
            <span style={{ verticalAlign: "middle" }}> | </span>
            <Button
              flat
              node="a"
              waves="light"
              id="btn-unselectall-showcolumn"
              style={{
                textDecoration: "underline",
                paddingLeft: "8px",
                paddingRight: "8px",
              }}
              onClick={handleEvents.BtnUnselectallShowColumn.OnClick}
            >
              NONE
            </Button>
          </div>
          <ShowColumnModalItems
            data={{
              columns: filterData?.columns ?? [],
              selectedFields: inputs?.selectedFields ?? [],
            }}
            handleEvents={handleEvents}
          />
        </div>
        <div key="modal-loading" className="modal-loading hide">
          <Html.Preloading
            addon={{
              css: {
                position: "absolute",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                margin: "auto",
              },
            }}
          />
        </div>
      </div>
    );
    footer = (
      <div className="modal-footer-bottom">
        <span className="modal-error-text hide"></span>
        <Button
          flat
          node="button"
          waves="light"
          id="btn-default-showcolumn"
          style={{ left: "0px", width: "100px" }}
          onClick={handleEvents.BtnDefaultShowColumn.OnClick}
        >
          Default
        </Button>
        <Button
          className=""
          id="btn-save-showcolumn"
          node="button"
          waves="light"
          small={true}
          style={{
            float: "right",
            width: "100px",
            borderRadius: "20px",
            right: "140px",
          }}
          onClick={handleEvents.BtnSaveShowColumn.OnClick}
        >
          SAVE
        </Button>
        <Button
          className="red accent-2"
          id="btn-cancel-showcolumn"
          node="button"
          waves="light"
          small={true}
          style={{ float: "right", width: "100px", borderRadius: "20px" }}
          onClick={handleEvents.BtnCancelShowColumn.OnClick}
        >
          CANCEL
        </Button>
      </div>
    );
  }

  return (
    <Modal
      actions={btns}
      bottomSheet={false}
      fixedFooter={false}
      className="modal-user modal-user-footer"
      id="showcolumn-modal-form"
      open={isOpen}
      options={{
        dismissible: true,
        endingTop: "10%",
        inDuration: 250,
        onCloseEnd: null,
        onCloseStart: handleEvents.BtnShowColumn.OnClose,
        onOpenEnd: null,
        onOpenStart: null,
        opacity: 0.5,
        outDuration: 250,
        preventScrolling: true,
        startingTop: "5%",
      }}
      root={document.getElementById("root")}
      style={modalCSS}
    >
      {content}
      {footer}
    </Modal>
  );
}

